import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../demoMode';
import { ScreenShell } from './ScreenShared';

async function parseApiResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  const rawText = await response.text();
  const looksJson = contentType.includes('application/json') || /^\s*[[{]/.test(rawText);

  if (!looksJson) {
    return { payload: null, rawText };
  }

  try {
    return { payload: JSON.parse(rawText), rawText };
  } catch {
    return { payload: null, rawText };
  }
}

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const formData = new URLSearchParams();
      formData.append('username', username.trim());
      formData.append('password', password);

      const response = await fetch(`${API_URL}/v1/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formData,
        credentials: 'include'
      });

      const { payload, rawText } = await parseApiResponse(response);
      if (!response.ok) {
        throw new Error(payload?.detail || `Unable to log in (HTTP ${response.status}). ${rawText ? 'Check API/proxy routing.' : ''}`);
      }

      if (!payload?.access_token) {
        throw new Error('Login response did not include an access token. Check API/proxy routing.');
      }

      onLogin(payload.access_token);
    } catch (err) {
      setError(err.message || 'Unable to log in.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScreenShell>
      <p className="figma-brand">INSTANT CONNECTIONS</p>
      <h2 className="figma-section-title">Welcome back</h2>
      <p className="figma-sub">Log in to enter the lounge.</p>

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit} className="figma-form">
        <label htmlFor="username">
          Username or Email
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="your_username"
            required
            disabled={loading}
          />
        </label>

        <label htmlFor="password">
          Password
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
            required
            disabled={loading}
          />
        </label>

        <button type="submit" className="figma-btn figma-btn-primary" disabled={loading}>
          {loading ? 'Signing in...' : 'Log in'}
        </button>
      </form>

      <Link to="/register" className="figma-btn figma-btn-secondary">
        Create account
      </Link>
    </ScreenShell>
  );
}

export default Login;
